import { useEffect, useState } from "react";
import { MessageCircle, GraduationCap, Briefcase } from "lucide-react";
import axios, { API } from "@/lib/api";
import { useSite } from "@/context/SiteContext";
import LoadingScreen from "@/components/shared/LoadingScreen";
import EmptyState from "@/components/shared/EmptyState";

export default function JamaahPembimbing() {
  const [guide, setGuide] = useState(undefined);
  const { settings } = useSite();

  useEffect(() => {
    axios.get(`${API}/jamaah/pembimbing`).then(({ data }) => setGuide(data)).catch(() => setGuide(null));
  }, []);

  if (guide === undefined) return <LoadingScreen />;

  return (
    <div data-testid="jamaah-pembimbing-page" className="space-y-6">
      <div>
        <h1 className="font-heading text-2xl font-bold text-[#1F2937]">Pembimbing Saya</h1>
        <p className="text-sm text-[#64748B]">Kontak pembimbing yang ditugaskan untuk program Anda.</p>
      </div>

      {!guide ? (
        <EmptyState title="Belum ada pembimbing ditugaskan" description="Pembimbing akan ditampilkan setelah program Anda dikonfirmasi." />
      ) : (
        <div className="rounded-2xl bg-white p-6 shadow-[0_2px_10px_rgba(15,107,79,0.05)]" data-testid="jamaah-guide-card">
          <div className="flex items-center gap-4">
            <img src={guide.photo_url} alt={guide.name} className="h-20 w-20 rounded-full object-cover ring-4 ring-[#0F6B4F]/10" />
            <div>
              <p className="font-heading text-lg font-semibold text-[#1F2937]">{guide.name}</p>
              <p className="text-sm text-[#1677B8]">{guide.position}</p>
            </div>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-[#64748B]">{guide.bio}</p>
          <div className="mt-4 space-y-2 text-sm text-[#1F2937]">
            <p className="flex items-center gap-2"><GraduationCap className="h-4 w-4 text-[#0F6B4F]" /> {guide.education}</p>
            <p className="flex items-center gap-2"><Briefcase className="h-4 w-4 text-[#0F6B4F]" /> {guide.experience}</p>
          </div>
          <a
            href={`https://wa.me/${guide.phone?.replace(/^0/, "62")}`}
            target="_blank"
            rel="noreferrer"
            data-testid="jamaah-contact-guide-button"
            className="mt-5 inline-flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-2.5 text-sm font-medium text-white hover:opacity-90"
          >
            <MessageCircle className="h-4 w-4" /> Hubungi via WhatsApp
          </a>
        </div>
      )}
    </div>
  );
}
